import { render, staticRenderFns } from "./ModalAgendamento.vue?vue&type=template&id=6d0bad5c&"
import script from "./ModalAgendamento.vue?vue&type=script&lang=js&"
export * from "./ModalAgendamento.vue?vue&type=script&lang=js&"
import style0 from "./ModalAgendamento.vue?vue&type=style&index=0&id=6d0bad5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports